export const CANTIDAD_ELEMENTOS_PAGINA = [
    {key: 'Mostrar 15 resultados', value: 15},
    {key: 'Mostrar 30 resultados', value: 30},
    {key: 'Mostrar 45 resultados', value: 45},
    {key: 'Mostrar 60 resultados', value: 60},
];